<div class="mb-3 mt-3 p-2 border rounded bg-light">
  <div class="row g-3">
    <div class="col-auto">
      <label>Name</label>
      <input
        class="form-control"
        name="name"
        placeholder="Filter by client name"
        [(ngModel)]="filters.name"
        (ngModelChange)="onFiltersChanged()"
      >
    </div>

    <div class="col-auto">
      <label>HRSA ID</label>
      <input
        class="form-control"
        name="hrsaId"
        placeholder="Filter by HRSA ID"
        [(ngModel)]="filters.hrsaId"
        (ngModelChange)="onFiltersChanged()"
      >
    </div>

    <div class="col-auto">
      <label>Active</label>
      <select class="form-select"
        [(ngModel)]="filters.active"
        (ngModelChange)="onFiltersChanged()" >
        <option value="any">Any</option>
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </select>
    </div>

    <div class="col-auto">
      <label>Terminated</label>
      <select class="form-select"
        [(ngModel)]="filters.terminated"
        (ngModelChange)="onFiltersChanged()">
        <option value="any">Any</option>
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </select>
    </div>

    <div class="col-auto">
      <label>Files Currently Importing</label>
      <select class="form-select"
        [(ngModel)]="filters.fileProcessingEnabled"
        (ngModelChange)="onFiltersChanged()">
        <option value="any">Any</option>
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </select>
    </div>

    <div class="col-auto">
      <label>Entity Type</label>
        <ng-select
          name="entityTypes"
          placeholder="Filter by entity type"
          [items]="entityTypeOptions"
          [(ngModel)]="filters.entityTypes"
          (ngModelChange)="onFiltersChanged()"
          [multiple]="true" />
    </div>

    <div class="col-auto">
      <label>State</label>
      <ng-select
        style="width: 220px"
        placeholder="Filter by state"
        bindValue="value"
        bindLabel="display"
        [(ngModel)]="filters.state"
        (ngModelChange)="onFiltersChanged()"
        [items]="stateOptions"
        name="state"/>
    </div>

    <div class="col-auto">
      <label>Assigned Client Leads</label>
      <ng-select
        style="width: 220px"
        name="assignedClientLeads"
        placeholder="Filter by client leads"
        [items]="assignedClientLeadOptions"
        [(ngModel)]="filters.assignedClientLeads"
        (ngModelChange)="onFiltersChanged()"
        [multiple]="true" />
    </div>

    <div class="col-12 col-md-auto ms-md-auto text-muted">
      Showing {{ filteredClients.length }} / {{ clients.length }}
      |
      <a class="text-danger reset-filters" href="#" (click)="clearFilters($event)">
        Reset Filters
      </a>
    </div>
  </div>
</div>

<table class="table table-bordered table-hover mb-0">
  <thead class="table-dark">
    <tr>
      <th>Full Name</th>
      <th>Active</th>
      <th>Go Live Date</th>
      <th>Name</th>
      <th>City, State</th>
      <th>Claim Identifier Prefixes</th>
      <th>HRSA IDs</th>
      <th>Fax Local</th>
      <th>Fax Tollfree</th>
      <th>Assigned Users</th>
      <th>Entity Types</th>
      <th>Files Currently Importing</th>
      <th>Terminated</th>
      <th>Client Id</th>
    </tr>
  </thead>
  <tbody>
    @for (client of filteredClients; track client) {
      <tr>
        <td>
          <a routerLink="/capture-admin/client-management/clients/{{client.id}}">
            {{ client.humanizedName }}
          </a>
          @if (canManageClients) {
            <div>
              <a href="#viewAsClient" (click)="onViewPortalClick($event, client)">View Portal</a>
              |
              <a href="#" routerLink="/capture-admin/client-management/clients/{{ client.id }}/edit" routerLinkActive="active">
                Edit Details
              </a>
              |
              @if (canManageClientConfigurations) {
                <a
                  href="#"
                  routerLink="/capture-admin/client-management/clients/{{ client.id }}/edit-configuration-options"
                  routerLinkActive="active">
                  Edit Config
                </a>
              }
              @if (!canManageClientConfigurations) {
                <a
                  href="#"
                  routerLink="/capture-admin/client-management/clients/{{ client.id }}/configuration-options"
                  routeLinkActive="active">
                  Show Config
                </a>
              }
            </div>
          }
        </td>
        <td>{{ clientActive(client) | booleanToYesNo }}</td>
        <td>{{ client.goLiveDate | date: 'MM/dd/yyyy'}}</td>
        <td>{{ client.name }}</td>
        <td>
          {{ client.city }}@if (client.city && client.state) {
          <span>, </span>
        }
        {{ client.state }}
        @if (!client.city && !client.state) {
          <span><app-blank-value-dash /></span>
        }
        </td>
        <td>{{ client.effectiveClaimIdentifierPrefixes.join(', ') | blankValueDash }}</td>
        <td>{{ client.effectiveHrsaIdStrings.join(', ') | blankValueDash }}</td>
        <td><app-phone-number [number]="client.faxLocal" /></td>
        <td><app-phone-number [number]="client.faxTollfree" /></td>
        <td>{{ assignedUsers(client) }}</td>
        <td>{{ client.entityTypes | joinList }}</td>
        <td>{{ client.fileProcessingEnabled | booleanToYesNo }}</td>
        <td>{{ client.terminated  | booleanToYesNo }}</td>
        <td>{{ client.id }}</td>
      </tr>
    }
  </tbody>
</table>
